export const SAFELISTING_HELP_DOMAIN = "safelisting" as const;

export const SAFELISTING_HELP_SCREENS = {
  form: "safelisting.form",
  list: "safelisting.list",
} as const;

export const SAFELISTING_FORM_HELP_KEYS = {
  household: "safelisting.form.household",
  datesRange: "safelisting.form.dates_range",
  excludedDates: "safelisting.form.excluded_dates",
  recipientName: "safelisting.form.recipient_name",
  recipientEmail: "safelisting.form.recipient_email",
  recipientPhone: "safelisting.form.recipient_phone",
  notes: "safelisting.form.notes",
  privateNotes: "safelisting.form.private_notes",
  overrides: "safelisting.form.overrides",
  overrideCountTowardTotal: "safelisting.form.override_count_toward_total",
  overrideLimit: "safelisting.form.override_limit",
  overrideDaysInARow: "safelisting.form.override_days_in_a_row",
  overrideReason: "safelisting.form.override_reason",
  submit: "safelisting.form.submit",
} as const;

export const SAFELISTING_LIST_HELP_KEYS = {
  search: "safelisting.list.search",
  filters: "safelisting.list.filters",
  rows: "safelisting.list.rows",
  /** @deprecated Prefer per-action keys; kept for tour fallbacks */
  row: "safelisting.list.row",
  rowActions: "safelisting.list.row_actions",
  actionView: "safelisting.list.action_view",
  actionEdit: "safelisting.list.action_edit",
  actionCancel: "safelisting.list.action_cancel",
  actionCorrectAccountability: "safelisting.list.action_correct_accountability",
  actionDelete: "safelisting.list.action_delete",
} as const;

export const SAFELISTING_HELP_TOURS = {
  listIntro: "safelisting.list.intro",
  formCreate: "safelisting.form.create",
} as const;
